var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 12.6292C6.81916 12.6292 6.64416 12.6058 6.49832 12.5533C4.26999 11.7892 0.729156 9.07665 0.729156 5.06915C0.729156 3.02749 2.37999 1.37082 4.40999 1.37082C5.39582 1.37082 6.31749 1.75582 6.99999 2.44415C7.68249 1.75582 8.60416 1.37082 9.58999 1.37082C11.62 1.37082 13.2708 3.03332 13.2708 5.06915C13.2708 9.08249 9.72999 11.7892 7.50166 12.5533C7.35582 12.6058 7.18082 12.6292 6.99999 12.6292ZM4.40999 2.24582C2.86416 2.24582 1.60416 3.51165 1.60416 5.06915C1.60416 9.05332 5.43666 11.27 6.78416 11.7308C6.88916 11.7658 7.11666 11.7658 7.22166 11.7308C8.56332 11.27 12.4017 9.05915 12.4017 5.06915C12.4017 3.51165 11.1417 2.24582 9.59582 2.24582C8.70916 2.24582 7.88666 2.65999 7.35582 3.37749C7.19249 3.59915 6.81916 3.59915 6.65582 3.37749C6.11332 2.65415 5.29666 2.24582 4.40999 2.24582Z",
    fill: "#0E1111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b1ecb16b4d827f4b801158bcd1aca406.svg";
export { ForwardRef as ReactComponent };